import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Col, Row, Image } from 'react-bootstrap';
import '../styles/craftsmanship.css';
import { useLocation } from "react-router-dom";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Craftsmanship = () => {

    const { pathname } = useLocation();

    const bannerRef = useRef(null);
    const bimgRef = useRef(null);
    const cbtitleRef = useRef(null);
    const infotitleRef = useRef(null);
    const infoRef = useRef(null);
    const infotextRef = useRef(null);
    const clastref = useRef(null);
    const clasttextref = useRef(null);

    const imgsRef = useRef([]);
    imgsRef.current = [];

    const textsRef = useRef([]);
    textsRef.current = [];

    // banner data animation
    useEffect(() => {
        gsap.fromTo(
            cbtitleRef.current, { y: 80, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                duration: 1.5,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: bannerRef.current,
                    start: "top 80%",
                },
            }
        );
    });

    // banner img animation
    useEffect(() => {
        if (!bimgRef.current) return;

        gsap.registerPlugin(ScrollTrigger);

        const animation = gsap.fromTo(
            bimgRef.current,
            { scale: 0.65 },
            {
                scale: 1.25,
                scrollTrigger: {
                    trigger: bimgRef.current,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                },
            }
        );

        return () => {
            animation.scrollTrigger?.kill();
            animation.kill();
        };
    }, []);

    // first data animation
    useEffect(() => {
        gsap.fromTo(
            infotitleRef.current, { y: 80, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                duration: 1.5,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: infoRef.current,
                    start: "top 80%",
                },
            }
        );

        gsap.fromTo(
            infotextRef.current,
            {
                opacity: 0,
                scale: 0.92,
                y: 20,
            },
            {
                opacity: 1,
                scale: 1,
                y: 0,
                duration: 1.3,
                ease: "power3.out",
            }
        );
    });

    // all imgs and texts animation
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        imgsRef.current.forEach((img, i) => {
            gsap.fromTo(
                img,
                { opacity: 0, scale: 0.9, x: i % 2 === 0 ? -80 : 80 },
                {
                    opacity: 1,
                    scale: 1,
                    x: 0,
                    duration: 1.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: img,
                        start: "top 80%",
                        end: "top 40%",
                        scrub: 1.2,
                    },
                }
            );
        });

        textsRef.current.forEach((text, i) => {
            gsap.fromTo(
                text,
                { opacity: 0, y: 40, x: i % 2 === 0 ? 40 : -40 },
                {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    duration: 1.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: text,
                        start: "top 85%",
                        end: "top 50%",
                        scrub: 1.1,
                    },
                }
            );
        });
    }, []);

    // last text animation
    useEffect(() => {
        gsap.fromTo(
            clasttextref.current, { y: 80, opacity: 0 },
            {
                y: 0,
                opacity: 1,
                duration: 1.5,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: clastref.current,
                    start: "top 80%",
                },
            }
        );
    });

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        });
    }, [pathname]);

    const images = {
        craftsmanship: require('../image/craftsmanship.png'),
        req: require('../image/req.png'),
        fabric: require('../image/selection.jpeg'),
        approval: require('../image/aprovel.png'),
        production: require('../image/production.jpg'),
        delivery: require('../image/delivery.jpg'),
    };

    return (
        <>
            <section className="Craftsmanship hero_slider" ref={bannerRef}>
                <div>
                    <img
                        ref={bimgRef}
                        src={images.craftsmanship}
                        className="d-block w-100 craftimg"
                        alt="img-1"
                        style={{
                            objectFit: 'cover', boxShadow: 'rgba(0, 0, 0, 7) 0px -50px 36px -28px inset',
                            maskImage:
                                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",
                            WebkitMaskImage:
                                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",

                        }}
                    />
                    <div className="carousel-caption-craftsmanship col-md-6 col-10 col-offset-md-6">
                        <h1 style={{ fontSize: '5.5rem' }} ref={cbtitleRef}>The Perfect Stitch</h1>
                    </div>
                </div>
            </section>

            <br /><br />

            <section className="infodata t-center mtb-3 d-flex justify-content-center align-items-center w-100%" ref={infoRef}>
                <div className='middletxt'>
                    <h3 ref={infotitleRef}>Craftsmanship That Defines Excellence</h3>
                    <br /><br />
                    <div ref={infotextRef}>
                        <p>With a large, skilled workforce, we handle bulk uniform orders seamlessly, ensuring every stitch meets our high standards</p>
                        <p>We create a wide range of uniforms, including corporate formal wear, blazers & kotis, chef coats & aprons, lab coats, safari suits, and worker uniforms, crafted for comfort and durability.</p>
                        <p>we can replicate any design exactly as provided by the client, delivering perfection in every detail.</p>
                    </div>
                </div>
            </section>

            <br /><br />

            <section className="datasteps py-5">
                {/* 1 */}
                <div className="step1 two-part-section position-relative">
                    <Row className="align-items-center">
                        <Col xs={12} md={6} className="p-0 image-side">
                            <Image
                                ref={(el) => imgsRef.current[1] = el}
                                src={images.req}
                                alt="Craftsmanship"
                                fluid
                                className="section-image"
                            />
                        </Col>
                        <Col xs={12} md={6} className="section-text text-center" ref={(el) => textsRef.current[1] = el}>
                            <div className="text-box py-5">
                                <h3>Understanding the Requirement</h3>
                                <br />
                                <p>We study your company’s style, needs, and uniform purpose.</p>
                            </div>
                        </Col>
                    </Row>
                </div>
                {/* 2 */}
                <div className="step1 two-part-section position-relative">
                    <Row className="align-items-center">
                        <Col xs={12} md={6} className="p-5 section-text" ref={(el) => textsRef.current[2] = el}>
                            <h3>Fabric Selection</h3>
                            <br />
                            <p>Choose from premium Mafatlal fabrics for comfort and quality.</p>
                        </Col>
                        <Col xs={12} md={6} className="p-0">
                            <Image
                                ref={(el) => imgsRef.current[2] = el}
                                src={images.fabric}
                                alt="Craftsmanship"
                                fluid
                                className="section-image"
                            />
                        </Col>
                    </Row>
                </div>
                {/* 3 */}
                <div className="step1 two-part-section position-relative">
                    <Row className="align-items-center">
                        <Col xs={12} md={6} className="p-0">
                            <Image
                                ref={(el) => imgsRef.current[3] = el}
                                src={images.approval}
                                alt="Craftsmanship"
                                fluid
                                className="section-image"
                            />
                        </Col>
                        <Col xs={12} md={6} className="p-5 section-text" ref={(el) => textsRef.current[3] = el}>
                            <h3>Sample Approval</h3>
                            <br />
                            <p>We craft and share a sample for your final confirmation.</p>
                        </Col>
                    </Row>
                </div>
                {/* 4 */}
                <div className="step1 two-part-section position-relative">
                    <Row className="align-items-center">
                        <Col xs={12} md={6} className="p-5 section-text" ref={(el) => textsRef.current[4] = el}>
                            <h3>Production</h3>
                            <br />
                            <p>Our expert team tailors bulk orders with precision and speed.</p>
                        </Col>
                        <Col xs={12} md={6} className="p-0">
                            <Image
                                ref={(el) => imgsRef.current[4] = el}
                                src={images.production}
                                alt="Craftsmanship"
                                fluid
                                className="section-image"
                            />
                        </Col>
                    </Row>
                </div>
                {/* 5 */}
                <div className="step1 two-part-section position-relative">
                    <Row className="align-items-center">
                        <Col xs={12} md={6} className="p-0">
                            <Image
                                ref={(el) => imgsRef.current[5] = el}
                                src={images.delivery}
                                alt="Craftsmanship"
                                fluid
                                className="section-image"
                            />
                        </Col>
                        <Col xs={12} md={6} className="p-5 section-text" ref={(el) => textsRef.current[5] = el}>
                            <h3>Final Delivery</h3>
                            <br />
                            <p>Each uniform undergoes quality checks and is delivered safely within the committed timeframe.</p>
                        </Col>
                    </Row>
                </div>
            </section >

            <br /><br /><br />

            <section className="infodata t-center pb-5" ref={clastref}>
                <Container className='middletxt pb-5'>
                    <h3 ref={clasttextref}>Craftsmanship that blends precision, passion, and perfection in every uniform we create</h3>
                </Container>
            </section>
        </>
    );
};

export default Craftsmanship;
